import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Sessão do console, guardada SEPARADA da sessão de mandato.
 *
 * Chave própria no armazenamento local, e não um campo a mais no `authStore`:
 * as duas sessões podem coexistir na mesma máquina (quem opera a plataforma
 * também pode ter um gabinete de teste), e misturá-las faria uma expulsar a
 * outra a cada login -- além de abrir caminho para mandar o token errado na
 * requisição errada.
 */
interface EstadoDaSessao {
  token: string | null;
  operador: { id: string; nome: string; email: string } | null;
  entrar: (token: string, operador: { id: string; nome: string; email: string }) => void;
  sair: () => void;
}

export const useSessaoDeOperador = create<EstadoDaSessao>()(
  persist(
    (set) => ({
      token: null,
      operador: null,
      entrar: (token, operador) => set({ token, operador }),
      sair: () => set({ token: null, operador: null }),
    }),
    { name: 'eleg360-operador' },
  ),
);
